import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { useParams } from "react-router-dom";
const CreateEmailComponent = loadable(
  () => import("../../components/User/CreateEmail")
);
const CreateEmail = ({ isOpen, setIsOpen }) => {
  const params = useParams();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["users-accounts"],
    navigateURL: "",
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.ACCOUNTS}`;
    let formData = {
      ...values,
      user: params.id,
    };
    try {
      await mutateAsync({ url, formData, setError });
      // if(res.status==201){
      //   naivate(`/users/edit/${res?.data?.id}`)
      // }
      setIsOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <CreateEmailComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateEmail;
